/** Enumeration of all API endpoints */
export enum Endpoint {
  // Misc
  HELLO = '/hello',

  // User
  USER_ME = '/user/me',
  USER_CHANGE_LOCALE = '/user/locale?email={email}',
  UPDATE_RECEIPT_EMAIL = '/user/billingEmail?billingEmail={billingEmail}',
  UPDATE_PREFERRED_PAYMENT_METHOD = '/user/preferredPaymentMethod?preferredPaymentMethod={paymentMethod}',

  // Organization
  ORGANIZATION_SEARCH = '/organization/all',
  UPDATE_ORGANIZATION_SUBSCRIPTION = '/organization/update/{id}/{toggleSubscription}',

  // Assignment
  GET_UPSELL_PAYMENT_INTENT_WITH_WORKSPACE = '/workspace/{workspaceId}/assignment/{assignmentId}/upsellPaymentIntent',
  GET_UPSELL_PAYMENT_INTENT = '/assignment/{assignmentId}/upsellPaymentIntent',

  // Order
  ORDER_CONFIGURATION_CATEGORY = '/order/configuration/category',
  ORDER_CONFIGURATION_ADDRESS = '/order/configuration/address',
  ORDER_CONFIGURATION_PRODUCT = '/order/configuration/product',
  ORDER_CONFIGURATION_INSTRUCTION = '/order/configuration/instruction',
  ORDER_PAYMENT_INTENT = '/order/paymentIntent',
  AUTOMATE_ORDER = '/order/{orderId}/automate',
  STOP_AUTOMATED_ORDER = '/order/{orderId}/stopAutomation',

  // Visual
  VISUAL_LIST_ALL = '/assignment/{assignmentId}/visual/all?type={type}',
  VISUAL_LIST_ALL_WITH_WORKSPACE = '/workspace/{workspaceId}/assignment/{assignmentId}/visual/all?type={type}',
  VISUAL_PURCHASE_SESSION_LIST_ALL = '/order/{sessionId}/visual/all?type={type}',
  VISUAL_DOWNLOAD_URL = '/assignment/{assignmentId}/visual/{filename}?type={type}',
  VISUAL_DOWNLOAD_URL_WITH_WORKSPACE = '/workspace/{workspaceId}/assignment/{assignmentId}/visual/{filename}?type={type}',
  VISUAL_PURCHASE_SESSION_DOWNLOAD_URL = '/order/{sessionId}/visual/{filename}?type={type}',
  VISUAL_UPLOAD_URL = '/assignment/{assignmentId}/visual/uploadUrl',
  VISUAL_UPLOAD_URL_BATCH = '/assignment/{assignmentId}/visual/uploadUrl/batch',
  UPLOAD_LEASE_HEARTBEAT = '/upload-lease/heartbeat',
  UPLOAD_LEASE_RELEASE = '/upload-lease/release',
  VISUAL_UPLOAD_URL_REPLACE = '/assignment/{assignmentId}/visual/uploadUrl',
  VISUAL_PURCHASE_SESSION_UPLOAD_URL = '/order/{sessionId}/visual/uploadUrl',
  VISUAL_PURCHASE_SESSION_UPLOAD_URL_REPLACE = '/order/{sessionId}/visual/uploadUrl',
  VISUAL_DELETE = '/assignment/{assignmentId}/visual/{filename}',
  VISUAL_DELETE_WITH_WORKSPACE = '/workspace/{workspaceId}/assignment/{assignmentId}/visual/{filename}',
  VISUAL_PURCHASE_SESSION_DELETE = '/order/{sessionId}/visual/{filename}',
  VISUAL_SELECT_WITH_WORKSPACE = '/workspace/{workspaceId}/assignment/{assignmentId}/visual/select',
  VISUAL_SELECT = '/assignment/{assignmentId}/visual/select',
  VISUAL_ARCHIVE = '/assignment/{assignmentId}/visual/archive',
  VISUAL_DOWNLOAD_ARCHIVE = '/assignment/{assignmentId}/visual/archive/{jobId}',
  VISUAL_DELETE_VIRTUAL_VISIT = '/assignment/{assignmentId}/virtualVisit',
  VISUAL_EXTEND_VIRTUAL_VISIT_WITH_WORKSPACE = '/workspace/{workspaceId}/assignment/{assignmentId}/virtualVisit/extendExpiration',
  VISUAL_EXTEND_VIRTUAL_VISIT = '/assignment/{assignmentId}/virtualVisit/extendExpiration',
  SELECT_VISUALS_FOR_STAGING = '/workspace/{workspaceId}/assignment/{assignmentId}/visual/staging/select',
  VISUAL_EDITING_ARCHIVE = '/assignment/{assignmentId}/editedVisuals/{exportId}/archive',

  // Visuals Editing
  WATERMARK_CRUD = '/workspace/{workspaceId}/assets/watermark/',
  WATERMARK_LOAD = '/workspace/{workspaceId}/assets/watermark/{watermarkId}',
  EDITED_VISUAL_DOWNLOAD_URL = '/assignment/{assignmentId}/editedVisuals/{jobId}/{filename}?type={type}',

  // Admin
  ADMIN_USER_CLIENT = '/user/client',
  ADMIN_ONBOARD_CLIENT = '/user/client/onboard',
  ADMIN_RESEND_CLIENT_INVITATION = '/user/resendInvitation',
  ADMIN_SEND_ASSIGNMENT_VISUALS_TO_CLIENT = '/assignment/{assignmentId}/deliver',
  ADMIN_SEND_ASSIGNMENT_VISUALS_TO_EDITOR = '/assignment/{assignmentId}/visual/edit',
  ADMIN_EDIT_ASSIGNMENT_ADMIN_COMMENTS_FOR_EDITOR = '/assignment/{assignmentId}/adminCommentsForEditor',
  ADMIN_EDIT_ASSIGNMENT_INTERNAL_COMMENTS = '/assignment/{assignmentId}/adminInternalComments',
  ADMIN_EDIT_ASSIGNMENT_CREATIVE_INSTRUCTIONS_FROM_ADMIN = '/assignment/{assignmentId}/creativeInstructionsFromAdmin',
  ADMIN_GET_TRANSLATION = '/translation/all',
  ADMIN_UPDATE_TRANSLATION = '/translation/updateBatch',
  ADMIN_CT_UNVAILABLE_LIST = '/assignment/{assignmentId}/creativesUnavailability',

  // GCP Job
  JOB = '/job/{id}',

  // Self edit visual with Pintura/Photo Studio
  SAVE_SELF_EDITED_VISUAL = '/workspace/{workspaceId}/assignment/{assignmentId}/self-edited-visuals/upload-url',
}

export enum OrderEndpoint {
  GET_POA_UPLOAD_URL = '/order/{orderId}/documents/upload-url',
  DELETE_UPLOADED_POA = '/order/{orderId}/documents/{filename}',
  ORDER_DOCUMENTS_INVOICES = '/order/{orderId}/documents/invoices',
}

export enum AssignmentDocumentsEndpoint {
  POST_UPLOAD_URL_WITH_WORKSPACE = '/workspace/{workspaceId}/assignment/{assignmentId}/documents/uploadUrl',
  POST_REUPLOAD_URL_WITH_WORKSPACE = '/workspace/{workspaceId}/assignment/{assignmentId}/documents/uploadUrl',
  DELETE_DOCUMENT_WITH_WORKSPACE = '/workspace/{workspaceId}/assignment/{assignmentId}/documents',
  POST_UPLOAD_URL = '/assignment/{assignmentId}/documents/uploadUrl',
  POST_REUPLOAD_URL = '/assignment/{assignmentId}/documents/uploadUrl',
  DELETE_DOCUMENT = '/assignment/{assignmentId}/documents',
}

export enum PurchaseFlowEndpoint {
  GET_POA_UPLOAD_URL = '/order/{sessionId}/power-of-attorney/uploadUrl',
  DELETE_UPLOADED_POA = '/order/{sessionId}/power-of-attorney',
  GET_POA_REPS_UPLOAD_URL = '/order/{sessionId}/power-of-attorney-representatives/uploadUrl',
  DELETE_UPLOADED_POA_REPS = '/order/{sessionId}/power-of-attorney-representatives',
  GET_DOCUMENT_UPLOAD_URL = '/order/{sessionId}/document/uploadUrl',
  DELETE_UPLOADED_DOCUMENT = '/order/{sessionId}/document/{filename}',
}

export enum PropertyEndpoint {
  GET_PROPERTY_DETAIL = '/workspace/{workspaceId}/realty/{propertyId}',
  GET_PROPERTY_ORDERS = '/workspace/{workspaceId}/realty/{propertyId}/orders',
  GET_PROPERTY_ASSIGNMENTS = '/workspace/{workspaceId}/realty/{propertyId}/assignments',
  GET_PROPERTY_DETAIL_WITH_OBJECT_REFERENCE = '/workspace/{workspaceId}/realty/object-reference-id/{objectReferenceId}',
  GET_PROPERTY_ORDER_STATUSES_WITH_OBJECT_REFERENCE = '/workspace/{workspaceId}/realty/object-reference-id/{objectReferenceId}/orders',
  GET_PROPERTY_REORDER_CONTEXT = '/workspace/{workspaceId}/realty/{propertyId}/reorder-context',
  GET_PROPERTY_REORDER_CONTEXT_WITH_OBJECT_REFERENCE = '/workspace/{workspaceId}/realty/object-reference-id/{objectReferenceId}/reorder-context',
  GET_SEARCH_PROPERTY = '/workspace/{workspaceId}/realty/search/text',
  GET_PROPERTY_BROKERS = '/workspace/{workspaceId}/realty/brokers',
  GET_PROPERTY_WORKSPACE = '/workspace/realty/{propertyId}/workspace',
  PATCH_PROPERTY_DETAIL = '/workspace/{workspaceId}/realty/{propertyId}',
  POST_CREATE_NEW_PROPERTY = '/workspace/{workspaceId}/realty/',
  POST_MERGE_PROPERTIES = '/workspace/{workspaceId}/realty/{targetPropertyId}/merge',
  POST_TRANSFER_PROPERTIES = '/workspace/{workspaceId}/realty/transfer',
  POST_BULK_DELETE_PROPERTIES = '/workspace/{workspaceId}/realty/bulk-delete',
  POST_REASSIGN_BROKER = '/workspace/{workspaceId}/realty/reassign-broker',
}

export enum VisualUploadEndpoints {
  GET_UPLOAD_URL = '/assignment/{assignmentId}/visual/uploadUrl',
  GET_UPLOAD_URL_BATCH = '/assignment/{assignmentId}/visual/uploadUrl/batch',
  GET_LOAD_URL = '/assignment/{assignmentId}/visual/{filename}', // Only used in creative upload page
  DELETE = '/assignment/{assignmentId}/visual/{filename}',
}

export enum PropertyVisualUploadEndpoints {
  POST_SELF_UPLOAD_VISUALS = '/{workspaceId}/realty/{realtyId}/self-upload-visuals/submit',
}

export enum CrmIntegrationEndpoint {
  LIST = '/workspace/{workspaceId}/crm-integrations',
  STORE_CREDENTIALS = '/workspace/{workspaceId}/crm-integrations/credentials/{crmType}',
  DELETE_CREDENTIALS = '/workspace/{workspaceId}/crm-integrations/credentials/{crmType}',
  TOGGLE_ENABLED = '/workspace/{workspaceId}/crm-integrations/credentials/{crmType}/enabled',
}

/** Marketing Automation (epic ISSUE-3615): gated by the `marketing-automation` flag, 404 when off. */
export enum SocialCampaignEndpoint {
  CAMPAIGN = '/workspace/{workspaceId}/realty/{realtyId}/social-campaign',
  CONTENT_INVENTORY = '/workspace/{workspaceId}/realty/{realtyId}/social-campaign/content-inventory',
  PLAN = '/workspace/{workspaceId}/realty/{realtyId}/social-campaign/plan',
  SETTINGS = '/workspace/{workspaceId}/realty/{realtyId}/social-campaign/settings',
  CONTENT_KIND = '/workspace/{workspaceId}/realty/{realtyId}/social-campaign/content-kinds/{kind}',
  CONTENT_KIND_VISUALS = '/workspace/{workspaceId}/realty/{realtyId}/social-campaign/content-kinds/{kind}/visuals',
  GENERATE = '/workspace/{workspaceId}/realty/{realtyId}/social-campaign/generate',
  POSTS = '/workspace/{workspaceId}/realty/{realtyId}/social-campaign/posts',
  POST = '/workspace/{workspaceId}/realty/{realtyId}/social-campaign/posts/{postId}',
  APPROVE_POST = '/workspace/{workspaceId}/realty/{realtyId}/social-campaign/posts/{postId}/approve',
  UNDO_POST_APPROVAL = '/workspace/{workspaceId}/realty/{realtyId}/social-campaign/posts/{postId}/undo-approval',
  POST_TEXT_ACTION = '/workspace/{workspaceId}/realty/{realtyId}/social-campaign/posts/{postId}/text/{action}',
  APPROVE_ALL = '/workspace/{workspaceId}/realty/{realtyId}/social-campaign/approve-all',
  PAUSE = '/workspace/{workspaceId}/realty/{realtyId}/social-campaign/pause',
  RESUME = '/workspace/{workspaceId}/realty/{realtyId}/social-campaign/resume',
  END = '/workspace/{workspaceId}/realty/{realtyId}/social-campaign/end',
  REOPEN = '/workspace/{workspaceId}/realty/{realtyId}/social-campaign/reopen',
}

export enum PropstackSessionEndpoint {
  EXCHANGE = '/integrations/propstack/session/exchange',
  REFRESH = '/integrations/propstack/session/refresh',
}

export enum OnOfficeSessionEndpoint {
  EXCHANGE = '/integrations/onoffice/session/exchange',
  REFRESH = '/integrations/onoffice/session/refresh',
}

/** crm-integrations endpoints, relative to its own base URL (`getCrmIntegrationsUrl()`), not the platform's. */
export enum CrmIntegrationsEndpoint {
  ONOFFICE_IFRAME_SESSION = '/api/v1/integrations/onoffice/iframe-session',
}

export enum InvoicingAddressesEndpoints {
  /** FOR CLIENTS */
  GET_ONE = '/user/me/invoicing-address/{addressId}',
  UPDATE = '/user/me/invoicing-address/{addressId}',
  DELETE = '/user/me/invoicing-address/{addressId}',
  GET_ALL = '/user/me/invoicing-address',
  CREATE = '/user/me/invoicing-address',

  /** FOR ADMINS */
  CREATE_FOR_USER_ID = '/user/{userId}/invoicing-address',
  GET_LIST_BY_USER_ID = '/user/{userId}/invoicing-address'
}

/** Photo Studio's Lab engine, run by the platform (backend-platform #571, ISSUE-3411) */
export enum PhotoStudioLabEndpoint {
  /** `{tool}`: one of `LabEngineTool` (models/photoStudio) */
  START_TOOL = '/assignment/{assignmentId}/ai-visuals/lab/{tool}',
  JOB = '/job/{id}',
  RESULT = '/assignment/{assignmentId}/ai-visuals/result',
}
